import React from 'react';

const UpgradePromptModal = ({ isOpen, onClose, title, message }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
            <div
                className="bg-(--surface) border border-(--border) rounded-2xl shadow-xl w-full max-w-md overflow-hidden animate-in zoom-in-95 duration-200"
                role="dialog"
                aria-modal="true"
                aria-labelledby="upgrade-modal-title"
                aria-describedby="upgrade-modal-desc"
            >
                <div className="p-6 space-y-4">
                    <div className="flex items-center justify-center w-12 h-12 bg-amber-500/10 text-amber-500 rounded-full mb-4">
                        <span className="text-2xl" aria-hidden="true">🔒</span>
                    </div>
                    <div>
                        <h3 id="upgrade-modal-title" className="text-xl font-black text-(--text)">
                            {title || 'Upgrade to Unlock'}
                        </h3>
                        <p id="upgrade-modal-desc" className="text-sm text-(--text-muted) mt-2 leading-relaxed">
                            {message || 'Your current plan does not include this feature or you have reached your usage limit.'}
                        </p>
                    </div>
                </div>
                <div className="bg-(--surface-stone) px-6 py-4 flex flex-col sm:flex-row items-center justify-end gap-3 border-t border-(--border)">
                    <button
                        onClick={onClose}
                        className="w-full sm:w-auto px-4 py-2 text-sm font-bold text-(--text-muted) hover:text-(--text) transition-colors"
                    >
                        Maybe Later
                    </button>
                    <button
                        onClick={() => window.location.href = '/'}
                        className="w-full sm:w-auto px-6 py-2 bg-(--accent) text-white text-sm font-bold rounded-full hover:bg-(--accent)/90 transition-colors shadow-sm"
                    >
                        View Plans
                    </button>
                </div>
            </div>
        </div>
    );
};

export default UpgradePromptModal;
